import React from 'react';
import { Talk } from '../../types';
import { useApp } from '../../context/AppContext';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionTitle from '../ui/SectionTitle';
import './Talks.css';

interface Props {
  talks: Talk[];
}

const Talks: React.FC<Props> = ({ talks }) => {
  const { t, lang } = useApp();
  const ref = useScrollReveal();

  return (
    <section className="talks" id="conferencias">
      <div className="talks__inner reveal-section" ref={ref as React.RefObject<HTMLDivElement>}>
        <SectionTitle
          eyebrow={lang === 'es' ? 'Del libro al escenario' : 'From the page to the stage'}
          title={lang === 'es' ? 'Dos keynotes, una misma convicción' : 'Two keynotes, one conviction'}
        />

        <div className="talks__grid">
          {talks.map((talk, i) => (
            <article key={talk.id} className="talk">
              <span className="talk__num">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="talk__title">{t(talk.title)}</h3>
              <p className="talk__hook">{t(talk.hook)}</p>
              {talk.paragraphs.map((p, j) => (
                <p key={j} className="talk__text">{t(p)}</p>
              ))}
              <div className="talk__foot">
                <span className="talk__format">{t(talk.format)}</span>
                <div className="talk__actions">
                  <a
                    className="talk__btn"
                    href={`mailto:dluquin@gmail.com?subject=${encodeURIComponent(talk.mailSubject)}`}
                  >
                    {lang === 'es' ? 'Consultar disponibilidad' : 'Check availability'}
                  </a>
                  {talk.link && (
                    <a className="talk__link" href={talk.link.href} target="_blank" rel="noopener noreferrer">
                      {t(talk.link.label)} →
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Talks;
